import React from "react"
import { Icon } from "../Icons"
import { Text } from "../Text"
import {
  FormControlError,
  FormControlErrorText,
} from "../gluestack/form-control"

interface FieldErrorProps {
  error?: string
}

interface FormErrorProps {
  error?: string
}

export const FieldError: React.FC<FieldErrorProps> = ({ error }) => {
  if (!error) return null
  return (
    <FormControlError className="gap-0">
      <Icon name="exclamation-circle" className="text-error-500 w-6 h-6" />
      <FormControlErrorText className="text-error-500 text-xs">
        {error}
      </FormControlErrorText>
    </FormControlError>
  )
}

export const FormError: React.FC<FormErrorProps> = ({ error }) => {
  if (!error) return null
  return (
    <div className="flex flex-row items-center gap-1 mt-1">
      <Icon name="exclamation-circle" className="text-error-500 w-4 h-4" />
      <Text className="text-error-500 text-xs">{error}</Text>
    </div>
  )
}
